import { injectPulsarTag } from './PulsarTag';
import { injectKruxTag } from './Krux';
import { timedOutInit } from './segment';

const MAX_DELAY = 8000;

export const timedOutLoadScripts = () => {
  setTimeout(() => {
    injectKruxTag();
    injectPulsarTag();
  }, MAX_DELAY);
};

export { injectKruxTag, timedOutInit };
